import { useQueries } from 'react-query';

import { RestQuery } from './types';
import { createQueryHookOptions } from './utils';

export const useRestQueries = <Response, Params>(queries: RestQuery<Response, Params>[]) =>
  useQueries(queries.map(createQueryHookOptions));
